import Vue from 'vue';
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/styles/skin.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/common.css';
import '@/assets/iconfont/iconfont.css';
import '@/assets/fxicon/iconfont.css';
import '@/assets/eleiconfont/iconfont.css';
import '@/assets/fxicon/iconfont';
import '@/assets/iconsx/iconfont';
import '@/assets/iconfont/iconfont';

Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.config.productionTip = false;
/**
 * SVG组件相关资源
 */
/* import ECharts from 'vue-echarts'
Vue.component('v-chart', ECharts)*/

store.dispatch('loadNoramlSvgIcons').then((res) => {
  res.forEach(f => {
    const componentInfo = {
      template: f.template,
      props: f.props
    }
    Vue.component(f.type, componentInfo)
  })
})
console.log(Vue)
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
